import { render } from "./MessengerRolesDialog.vue?vue&type=template&id=391718ce"
import script from "./MessengerRolesDialog.vue?vue&type=script&lang=js"
export * from "./MessengerRolesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__